import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconChevronUpStyle0 = cosmosIconCss;

const CosmosIconChevronUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconChevronUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f14b000a9d9bd68d2228f25ec73722f7382150cd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6b82fab5d14b28612e3bd2f8feabb0988f453f10', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '656b9176c77cd98842ad3bd37ecff4f2ffdba618', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.65 6.29-5.82 5.83a.48.48 0 0 0 0 .7l.35.36a.51.51 0 0 0 .71 0L11 8.06l5.11 5.12a.51.51 0 0 0 .71 0l.35-.36a.48.48 0 0 0 0-.7l-5.81-5.83a.51.51 0 0 0-.71 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconChevronUpStyle0; }
}, [1, "cosmos-icon-chevron-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chevron-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chevron-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChevronUp$1);
            }
            break;
    } });
}

const CosmosIconChevronUp = CosmosIconChevronUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronUp, defineCustomElement };
